export const formatCardNumber = (cardNumber: string): string => {
  return cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
};
